export default "__VITE_ASSET__B1k3rP3K__"